<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Pass Booking Submission</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Filter -->
        <div class="row align-items-center">
            <div class="col-md-3 fit-content">Type of Pass</div>
            <div class="col-md-3 pl-md-0">
                <select class="custom-select fit-content" v-model="passId">
                    <option value="">-- Please Select --</option>
                    <option v-for="(item, i) in passes" :key="i" :value="item.Id">
                        {{ item.Name }}
                    </option>
                </select>
            </div>
            <div class="col-md-2 text-right" style="max-width:180px" v-if="role == 'admin'">Search Employee Name/ID to Apply</div>
            <div class="col-md-5 pl-md-0" v-if="role == 'admin'">
                <Select2 v-model="userId" :options="employees" />
            </div>
        </div>
        <div class="row align-items-center mt-2" v-if="role == 'admin'">
            <!-- <div class="col-md-5"></div> -->
            <div class="col-md-6 text-right">On Behalf of</div>
            <div class="col-md-4 pl-md-0">
                {{ employee }}
                <button v-if="userId" type="button" class="btn btn-secondary btn-sm remove-user-btn"
                    @click="userId = ''">
                    <i class="fa fa-close"></i>
                </button>
            </div>
        </div>
        <!-- /Filter -->

        <!-- Calendar Filter-->
        <div class="row align-items-center mt-4">
            <div class="col-md-12 text-center font-red">
                <span v-if="record && record.IsYearlyLimitReached">
                    You booked {{ record.YearlyLimit }} time/s in this year.
                </span>
                <span v-if="record && !record.IsYearlyLimitReached && record.IsQuarterlyLimitReached">
                    You booked {{ record.QuarterlyLimit }} time/s in Q{{ quarterNo }}.
                </span>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-3 pl-md-0">
                <button v-if="!isHidePrevMonthButton" type="button" class="btn btn-link" @click="prevMonth">
                    &lt;&lt;prev month
                </button>
            </div>
            <div class="col-md-6 text-center">
                <select class="custom-select fit-content custom-select-sm" v-model="month" @change="onMonthChanged">
                    <option value="1">Jan</option>
                    <option value="2">Feb</option>
                    <option value="3">Mar</option>
                    <option value="4">Apr</option>
                    <option value="5">May</option>
                    <option value="6">Jun</option>
                    <option value="7">Jul</option>
                    <option value="8">Aug</option>
                    <option value="9">Sep</option>
                    <option value="10">Oct</option>
                    <option value="11">Nov</option>
                    <option value="12">Dec</option>
                </select>
                <select class="custom-select fit-content custom-select-sm" v-model="year" @change="onYearChanged">
                    <option v-for="item in years" :key="item">{{ item }}</option>
                </select>
            </div>
            <div class="col-md-3 text-right">
                <button v-if="!isHideNextMonthButton" type="button" class="btn btn-link" @click="nextMonth">
                    next month&gt;&gt;
                </button>
            </div>
        </div>
        <!-- /Calendar Filter-->

        <!-- New Employee Message -->
        <!--<div class="mt-4 mb-4" style="padding: 15px 15px 1px; background-color: #FFF;">
            <p>
            E-tickets cannot be used during eve of Public Holidays and on Public Holidays
            </p>
        </div>-->
        <!-- /New Employee Message -->

        <!-- Calendar -->
        <div class="row mt-2">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>Monday</th>
                                <th>Tuesday</th>
                                <th>Wednesday</th>
                                <th>Thursday</th>
                                <th>Friday</th>
                                <th>Saturday</th>
                                <th>Sunday</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- First Row -->
                            <tr v-if="firstRowDates && firstRowDates.length" class="content-row">
                                <td v-for="item in firstRowDates"
                                    :class="item.IsPublicHoliday ? 'holiday-cell' : (item.IsDisabled ? 'disabled-cell' : '')">
                                    <table v-if="item.Day" class="inner-table">
                                        <tr class="first-row">
                                            <td>
                                                <button type="button" class="btn btn-link"
                                                    @click="showBookingModal(item)" v-if="item.TotalAvailablePass > 0">
                                                    {{
                                                        ( record && record.Type && record.Type == corporatePassType.physicalCard ) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </button>
                                                <span v-else>
                                                    {{
                                                        item.IsDisabled || ( record && record.Type && record.Type == corporatePassType.physicalCard )
                                                            || (role == "admin" && !userId) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </span>
                                            </td>
                                            <td></td>
                                            <td class="date-cell">{{ item.Day }}</td>
                                        </tr>
                                        <tr class="second-row">
                                            <td></td>
                                            <td class="text-center">
                                                <template v-if="item.IsPublicHoliday">
                                                    {{ item.PublicHolidayName }}<br />
                                                </template>
                                                <template v-if="item.IsFullyBooked">
                                                    Fully Booked
                                                </template>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr class="third-row" v-if="item.Employees && item.Employees.length">
                                            <td></td>
                                            <td>
                                                <div v-for="(item, i) in item.Employees">
                                                    {{ (i + 1) }}. {{ item.EmployeeName }} [{{ item.TotalPassBooked }}]
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <!-- /First Row -->

                            <!-- Second Row -->
                            <tr v-if="secondRowDates && secondRowDates.length" class="content-row">
                                <td v-for="item in secondRowDates"
                                    :class="item.IsPublicHoliday ? 'holiday-cell' : (item.IsDisabled ? 'disabled-cell' : '')">
                                    <table v-if="item.Day" class="inner-table">
                                        <tr class="first-row">
                                            <td>
                                                <button type="button" class="btn btn-link"
                                                    @click="showBookingModal(item)" v-if="item.TotalAvailablePass > 0">
                                                    {{
                                                        ( record && record.Type && record.Type == corporatePassType.physicalCard ) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </button>
                                                <span v-else>
                                                    {{
                                                        item.IsDisabled || ( record && record.Type && record.Type == corporatePassType.physicalCard )
                                                            || (role == "admin" && !userId) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </span>
                                            </td>
                                            <td></td>
                                            <td class="date-cell">{{ item.Day }}</td>
                                        </tr>
                                        <tr class="second-row">
                                            <td></td>
                                            <td class="text-center">
                                                <template v-if="item.IsPublicHoliday">
                                                    {{ item.PublicHolidayName }}<br />
                                                </template>
                                                <template v-if="item.IsFullyBooked">
                                                    Fully Booked
                                                </template>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr class="third-row" v-if="item.Employees && item.Employees.length">
                                            <td></td>
                                            <td>
                                                <div v-for="(item, i) in item.Employees">
                                                    {{ (i + 1) }}. {{ item.EmployeeName }} [{{ item.TotalPassBooked }}]
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <!-- /Second Row -->

                            <!-- Third Row -->
                            <tr v-if="thirdRowDates && thirdRowDates.length" class="content-row">
                                <td v-for="item in thirdRowDates"
                                    :class="item.IsPublicHoliday ? 'holiday-cell' : (item.IsDisabled ? 'disabled-cell' : '')">
                                    <table v-if="item.Day" class="inner-table">
                                        <tr class="first-row">
                                            <td>
                                                <button type="button" class="btn btn-link"
                                                    @click="showBookingModal(item)" v-if="item.TotalAvailablePass > 0">
                                                    {{
                                                        ( record && record.Type && record.Type == corporatePassType.physicalCard ) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </button>
                                                <span v-else>
                                                    {{
                                                        item.IsDisabled || ( record && record.Type && record.Type == corporatePassType.physicalCard )
                                                            || (role == "admin" && !userId) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </span>
                                            </td>
                                            <td></td>
                                            <td class="date-cell">{{ item.Day }}</td>
                                        </tr>
                                        <tr class="second-row">
                                            <td></td>
                                            <td class="text-center">
                                                <template v-if="item.IsPublicHoliday">
                                                    {{ item.PublicHolidayName }}<br />
                                                </template>
                                                <template v-if="item.IsFullyBooked">
                                                    Fully Booked
                                                </template>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr class="third-row" v-if="item.Employees && item.Employees.length">
                                            <td></td>
                                            <td>
                                                <div v-for="(item, i) in item.Employees">
                                                    {{ (i + 1) }}. {{ item.EmployeeName }} [{{ item.TotalPassBooked }}]
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <!-- /Third Row -->

                            <!-- Fourth Row -->
                            <tr v-if="fourthRowDates && fourthRowDates.length" class="content-row">
                                <td v-for="item in fourthRowDates"
                                    :class="item.IsPublicHoliday ? 'holiday-cell' : (item.IsDisabled ? 'disabled-cell' : '')">
                                    <table v-if="item.Day" class="inner-table">
                                        <tr class="first-row">
                                            <td>
                                                <button type="button" class="btn btn-link"
                                                    @click="showBookingModal(item)" v-if="item.TotalAvailablePass > 0">
                                                    {{
                                                        ( record && record.Type && record.Type == corporatePassType.physicalCard ) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </button>
                                                <span v-else>
                                                    {{
                                                        item.IsDisabled || ( record && record.Type && record.Type == corporatePassType.physicalCard )
                                                            || (role == "admin" && !userId) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </span>
                                            </td>
                                            <td></td>
                                            <td class="date-cell">{{ item.Day }}</td>
                                        </tr>
                                        <tr class="second-row">
                                            <td></td>
                                            <td class="text-center">
                                                <template v-if="item.IsPublicHoliday">
                                                    {{ item.PublicHolidayName }}<br />
                                                </template>
                                                <template v-if="item.IsFullyBooked">
                                                    Fully Booked
                                                </template>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr class="third-row" v-if="item.Employees && item.Employees.length">
                                            <td></td>
                                            <td>
                                                <div v-for="(item, i) in item.Employees">
                                                    {{ (i + 1) }}. {{ item.EmployeeName }} [{{ item.TotalPassBooked }}]
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <!-- /Fourth Row -->

                            <!-- Fifth Row -->
                            <tr v-if="fifthRowDates && fifthRowDates.length" class="content-row">
                                <td v-for="item in fifthRowDates"
                                    :class="item.IsPublicHoliday ? 'holiday-cell' : (item.IsDisabled ? 'disabled-cell' : '')">
                                    <table v-if="item.Day" class="inner-table">
                                        <tr class="first-row">
                                            <td>
                                                <button type="button" class="btn btn-link"
                                                    @click="showBookingModal(item)" v-if="item.TotalAvailablePass > 0">
                                                    {{
                                                        ( record && record.Type && record.Type == corporatePassType.physicalCard ) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </button>
                                                <span v-else>
                                                    {{
                                                        item.IsDisabled || ( record && record.Type && record.Type == corporatePassType.physicalCard )
                                                            || (role == "admin" && !userId) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </span>
                                            </td>
                                            <td></td>
                                            <td class="date-cell">{{ item.Day }}</td>
                                        </tr>
                                        <tr class="second-row">
                                            <td></td>
                                            <td class="text-center">
                                                <template v-if="item.IsPublicHoliday">
                                                    {{ item.PublicHolidayName }}<br />
                                                </template>
                                                <template v-if="item.IsFullyBooked">
                                                    Fully Booked
                                                </template>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr class="third-row" v-if="item.Employees && item.Employees.length">
                                            <td></td>
                                            <td>
                                                <div v-for="(item, i) in item.Employees">
                                                    {{ (i + 1) }}. {{ item.EmployeeName }} [{{ item.TotalPassBooked }}]
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <!-- /Fifth Row -->

                            <!-- Sixth Row -->
                            <tr v-if="sixthRowDates && sixthRowDates.length" class="content-row">
                                <td v-for="item in sixthRowDates"
                                    :class="item.IsPublicHoliday ? 'holiday-cell' : (item.IsDisabled ? 'disabled-cell' : '')">
                                    <table v-if="item.Day" class="inner-table">
                                        <tr class="first-row">
                                            <td>
                                                <button type="button" class="btn btn-link"
                                                    @click="showBookingModal(item)" v-if="item.TotalAvailablePass > 0">
                                                    {{
                                                        ( record && record.Type && record.Type == corporatePassType.physicalCard ) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </button>
                                                <span v-else>
                                                    {{
                                                        item.IsDisabled || ( record && record.Type && record.Type == corporatePassType.physicalCard )
                                                            || (role == "admin" && !userId) ? "[" +
                                                            item.TotalAvailablePhysicalPass + "]" : "Book"
                                                    }}
                                                </span>
                                            </td>
                                            <td></td>
                                            <td class="date-cell">{{ item.Day }}</td>
                                        </tr>
                                        <tr class="second-row">
                                            <td></td>
                                            <td class="text-center">
                                                <template v-if="item.IsPublicHoliday">
                                                    {{ item.PublicHolidayName }}<br />
                                                </template>
                                                <template v-if="item.IsFullyBooked">
                                                    Fully Booked
                                                </template>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr class="third-row" v-if="item.Employees && item.Employees.length">
                                            <td></td>
                                            <td>
                                                <div v-for="(item, i) in item.Employees">
                                                    {{ (i + 1) }}. {{ item.EmployeeName }} [{{ item.TotalPassBooked }}]
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <!-- /Sixth Row -->
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Calendar -->

        <!-- Modal Popup -->
        <div class="modal custom-modal fade" id="bookingModal" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-0 pb-3">
                        <form @submit.prevent="confirm">
                            <div class="row align-items-center" v-if="role == 'admin'">
                                <div class="col-md-4">Apply on Behalf of</div>
                                <div class="col-md-8">{{ this.employee }}</div>
                            </div>
                            <div class="row align-items-center">
                                <div class="col-md-4">Booking Date</div>
                                <div class="col-md-8">{{ this.bookingDate }}</div>
                            </div>
                            <div class="row align-items-center mt-1">
                                <div class="col-md-4">Number of Pass/E-Tickets</div>
                                <div class="col-md-8">
                                    <select class="custom-select fit-content custom-select-sm" v-model="numberOfPass">
                                        <option v-for="item in numberOfPasses" :key="item">{{ item }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row align-items-center mt-1" v-if="( record && record.Type && record.Type == corporatePassType.eTicket )">
                                <div class="col-md-4">Mobile Number</div>
                                <div class="col-md-8">
                                    <input type="text" class="form-control form-control-sm fit-content mobileonly"
                                        v-model="mobileNumber" minlength="8" maxlength="20" required />
                                </div>
                            </div>
                            <hr />
                            <div class="row align-items-center">
                                <div class="col-md-12 text-center">
                                    <button type="submit" class="btn btn-sm btn-primary mr-2">Confirm</button>
                                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"
                                        aria-label="Close">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- /Modal Popup -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import $ from "jquery";
export default {
    data() {
        return {
            passes: [],
            passId: "",
            employees: [],
            userId: "",
            //calendar
            record: null,
            month: new Date().getMonth() + 1,
            years: [],
            year: new Date().getFullYear(),
            maxYearCount: 1,
            firstRowDates: [],
            secondRowDates: [],
            thirdRowDates: [],
            fourthRowDates: [],
            fifthRowDates: [],
            sixthRowDates: [],
            //modal popup
            numberOfPasses: [],
            numberOfPass: "",
            bookingDate: "",
            day: "",
            mobileNumber: ""
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isHidePrevMonthButton() {
            let currentYear = new Date().getFullYear();
            return this.month == 1 && this.year == currentYear;
        },
        isHideNextMonthButton() {
            let maxYear = new Date().getFullYear() + this.maxYearCount;
            return this.month == 12 && this.year == maxYear;
        },
        employee() {
            let user = this.employees.find(c => c.id == this.userId);
            if (user) {
                let textArray = user.text.split(" - ");
                return textArray[0];
            }
            else return "";
        },
        quarterNo() {
            if (this.month == 1 || this.month == 2 || this.month == 3) return 1;
            if (this.month == 4 || this.month == 5 || this.month == 6) return 2;
            if (this.month == 7 || this.month == 8 || this.month == 9) return 3;
            if (this.month == 10 || this.month == 11 || this.month == 12) return 4;
        },
        corporatePassType() {
            let type = {
                physicalCard: config.CORPORATE_PASS_TYPE_PHYSICAL_CARD,
                eTicket: config.CORPORATE_PASS_TYPE_ETICKET
            }
            return type;
        }
    },

    watch: {
        passId(val) {
            this.getCorporatePassBookings();
        },
        userId(val) {
            if (!this.passId) return;
            this.getCorporatePassBookings();
        }
    },

    methods: {
        //filter
        getPasses() {
            let param = {
                Token: this.token,
                Company: config.DEFAULT_COMPANY
            }
            this.$store.state.isLoading = true;
            API.getCorporatePass(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.passes = response.data.record.filter(c => c.Status == "Active");
                        this.passId = this.passes[0].Id;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getEmployees() {
            let param = { Token: this.token };
            this.$store.state.isLoading = true;
            API.getEmployees(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.employees = response.data.recordForCorppassBooking;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //calendar filter
        onMonthChanged() {
            if (!this.passId) {
                alert("Please select a pass.");
                return;
            }
            this.getCorporatePassBookings();
        },
        onYearChanged() {
            if (!this.passId) {
                alert("Please select a pass.");
                return;
            }
            this.getCorporatePassBookings();
        },
        getYears() {
            let date = new Date();
            let maxYear = date.getFullYear() + this.maxYearCount;
            this.years = [];
            for (let year = date.getFullYear(); year <= maxYear; year++) {
                this.years.push(year);
            }
        },
        prevMonth() {
            if (!this.passId) {
                alert("Please select a pass.");
                return;
            }
            this.month = parseInt(this.month) - 1;
            if (this.month < 1) {
                this.month = 12;
                this.year = parseInt(this.year) - 1;
            }
            this.getCorporatePassBookings();
        },
        nextMonth() {
            if (!this.passId) {
                alert("Please select a pass.");
                return;
            }
            this.month = parseInt(this.month) + 1;
            if (this.month > 12) {
                this.month = 1;
                this.year = parseInt(this.year) + 1;
            }
            this.getCorporatePassBookings();
        },
        //calendar
        getCorporatePassBookings() {
            let tokenObj = JSON.parse(localStorage.getItem("lambitoken"));
            let param = {
                Token: this.token,
                PassId: this.passId,
                Month: this.month,
                Year: this.year,
                UserId: this.role == "admin" ? this.userId : tokenObj.Id
            }
            this.$store.state.isLoading = true;
            API.getCorporatePassBookings(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.record = response.data.record;
                        this.loadCalendar(response.data.record.Details);
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        loadCalendar(records) {
            this.firstRowDates = [];
            this.secondRowDates = [];
            this.thirdRowDates = [];
            this.fourthRowDates = [];
            this.fifthRowDates = [];
            this.sixthRowDates = [];
            let index = 0;
            //populate first row
            for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
                if (records[index].DayOfWeek == dayOfWeek) {
                    this.firstRowDates.push(records[index]);
                    index++;
                } else {
                    this.firstRowDates.push({
                        Day: null, DayOfWeek: null, DateDisplay: null, TotalAvailablePass: null, IsPublicHoliday: null,
                        PublicHolidayName: null, IsFullyBooked: null, IsDisabled: false, Employees: [], TotalAvailablePhysicalPass: null
                    });
                }
            }

            //populate second row
            for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
                this.secondRowDates.push(records[index]);
                index++;
            }
            //populate third row
            for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
                this.thirdRowDates.push(records[index]);
                index++;
            }
            //populate fourth row
            for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
                this.fourthRowDates.push(records[index]);
                index++;
            }
            //populate fifth row
            if (!records.hasOwnProperty(index)) return;
            for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
                if (records.hasOwnProperty(index)) {
                    this.fifthRowDates.push(records[index]);
                    index++;
                } else {
                    this.fifthRowDates.push({
                        Day: null, DayOfWeek: null, DateDisplay: null, TotalAvailablePass: null, IsPublicHoliday: null,
                        PublicHolidayName: null, IsFullyBooked: null, IsDisabled: false, Employees: [], TotalAvailablePhysicalPass: null
                    });
                }
            }
            //populate sixth row
            if (!records.hasOwnProperty(index)) return;
            for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
                if (records.hasOwnProperty(index)) {
                    this.sixthRowDates.push(records[index]);
                    index++;
                } else {
                    this.sixthRowDates.push({
                        Day: null, DayOfWeek: null, DateDisplay: null, TotalAvailablePass: null, IsPublicHoliday: null,
                        PublicHolidayName: null, IsFullyBooked: null, IsDisabled: false, Employees: [], TotalAvailablePhysicalPass: null
                    });
                }
            }
        },
        //for modal popup
        showBookingModal(item) {
            if (this.role == "admin" && !this.userId) {
                alert("Please select an employee.");
                return;
            }
            this.bookingDate = item.DateDisplay;
            this.numberOfPasses = [];
            for (let i = 1; i <= item.TotalAvailablePass; i++) {
                this.numberOfPasses.push(i);
            }
            this.numberOfPass = item.TotalAvailablePass;
            this.day = item.Day;
            $("#bookingModal").modal({
                backdrop: "static",
                keyboard: false,
            });
        },
        confirm() {
            let tokenObj = JSON.parse(localStorage.getItem("lambitoken"));
            let param = {
                Token: this.token,
                UserId: this.role == "admin" ? this.userId : tokenObj.Id,
                PassId: this.passId,
                Day: this.day,
                Month: this.month,
                Year: this.year,
                NumberOfPass: this.numberOfPass,
                MobileNumber: this.mobileNumber
            }
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to book the pass?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.bookCorporatePass(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                $("#bookingModal").modal("hide");
                                this.getCorporatePassBookings();
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        }
    },

    created() {
        this.getPasses();
        this.getEmployees();
        this.getYears();
    }
}
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}

.link-underline a:hover {
    text-decoration: underline;
}

.btn-link {
    color: #007bff;
}

table th {
    text-align: center;
    width: 14.28%
}

.disabled-cell {
    background-color: #e5e4e2;
}

.holiday-cell {
    background-color: #ffe4d4;
}

.table.custom-table>tbody>tr>td {
    height: 110px;
    padding: 0 !important;
    vertical-align: top;
}

.date-cell {
    font-weight: bold;
    text-align: right;
}

.inner-table {
    width: 100%;
    height: 100%;
}

.inner-table tr {
    background-color: unset;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.inner-table td {
    border-style: hidden !important;
}

.inner-table .first-row td {
    padding-bottom: 0;
}

.inner-table .second-row td {
    padding-top: 0;
    padding-bottom: 0;
    font-size: 13px;
}

.inner-table .third-row td {
    font-size: 13px;
}

.remove-user-btn {
    height: 23px;
    width: 23px;
    padding-left: 5px;
    padding-top: 1px;
}

.font-red {
    color: red;
}

.table-bordered th,
.table-bordered td {
    border: 1px solid #D3D3D3;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/SubmitCorporatePass.vue